module.exports = __webpack_public_path__ + "assets/img/vector-1.d98ba54e.svg";